import React from "react";
import SearchSortTable from "components/Table";
import { ColumnDef } from "@tanstack/react-table";
import useModulesTableColumns from "./useModulesTableColumns";
import clsx from "clsx";
import { operationalEmissionsStore } from "../OperationalEmissionsStore";

const ModulesTable = ({ certKey }: { certKey?: string }) => {
  const data =
    operationalEmissionsStore.certificationsData?.[certKey as string];
  if (!data) return null;

  const tableData = Object.values(data?.columns);

  const getColumns = () => {
    return useModulesTableColumns(certKey as string);
  };

  return (
    <div className="pb-2 bg-gray-50">
      <SearchSortTable
        data={tableData}
        getColumns={getColumns as () => ColumnDef<unknown, unknown>[]}
        headerDivStyle={clsx(
          "!py-0 h-[17px] !px-2 !text-sm font-semibold text-gray-900"
        )}
        headerColumnStyle={clsx(
          "border-r last-of-type:border-r-0 border-gray-300 first-of-type:pl-2 last-of-type:pr-2"
        )}
        customColumnStyle={clsx(
          "border-r last-of-type:border-r-0 border-gray-300 !py-1.5 first-of-type:pl-4 last-of-type:pr-4"
        )}
        scrollDivClassName="border-y border-gray-300"
      />
    </div>
  );
};

export default ModulesTable;
